
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { User, UserCog, UserX, UserMinus, MoreVertical, Edit } from 'lucide-react';
import { AdminUser } from '@/lib/types';

interface UserActionsMenuProps {
  user: AdminUser;
  isSuperuser: boolean;
  onStatusToggle: () => void;
  onMakeAdmin: () => void;
  onRemoveAdmin: () => void;
  onImpersonate: () => void;
  onEdit: () => void;
  onDeactivate: () => void;
}

export default function UserActionsMenu({
  user,
  isSuperuser,
  onStatusToggle,
  onMakeAdmin,
  onRemoveAdmin,
  onImpersonate,
  onEdit,
  onDeactivate
}: UserActionsMenuProps) {
  if (!isSuperuser) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm">
          <MoreVertical className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onClick={onStatusToggle}>
          <UserX className="mr-2 h-4 w-4" />
          {user.is_active ? 'Suspend' : 'Activate'}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem 
          onClick={onDeactivate}
          className="text-red-600"
        >
          <UserMinus className="mr-2 h-4 w-4" />
          Deactivate User
        </DropdownMenuItem>
        {user.role === 'user' && (
          <DropdownMenuItem onClick={onMakeAdmin}>
            <UserCog className="mr-2 h-4 w-4" />
            Make Admin
          </DropdownMenuItem>
        )}
        {user.role === 'admin' && (
          <DropdownMenuItem onClick={onRemoveAdmin}>
            <UserCog className="mr-2 h-4 w-4" />
            Remove Admin
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onImpersonate}>
          <User className="mr-2 h-4 w-4" />
          Impersonate
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onEdit}>
          <Edit className="mr-2 h-4 w-4" />
          Edit User
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
